// API Configuration
const API_BASE_URL =
  // "http://localhost:8080";
  "https://api-third-shot-score-684526581556.asia-south1.run.app";
// const API_BASE_URL = "https://api-third-shot-score-684526581556.asia-south1.run.app";

export const API_ENDPOINTS = {
  PLAYERS_SORTED_BY_SCORE: `${API_BASE_URL}/players/sorted-by-score`,
  PLAYERS: `${API_BASE_URL}/players`,
  TEAMS: `${API_BASE_URL}/teams`,
  TEAMS_LEADERBOARD: `${API_BASE_URL}/teams/leaderboard`,
};

export default API_BASE_URL;
